import { ICON__check } from '@/assets/icons_fa';
import { use_component_is_mounted_300 } from '@/hooks/is_mounted/use_component_is_mounted_300';
import { cn } from '@/utils/utils_client';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import * as React from 'react';

export const UI_PRIMITIVE__checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => {
  const { is_mounted } = use_component_is_mounted_300();

  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        `cursor-pointer hover-animation ${is_mounted ? 'opacity-100 scale-100' : '!opacity-0 !scale-50'} peer h-4 w-4 shrink-0 rounded-sm border 
        border-component-item-action   
        dark:border-component-item-action 

        focus-visible:outline-none 

        disabled:cursor-not-allowed 
        disabled:opacity-50 
        
        data-[state=checked]:bg-component-item-action 
        dark:data-[state=checked]:bg-component-item-action 
        
        data-[state=checked]:text-component 
        dark:data-[state=checked]:text-component
        `,
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator className={cn('flex items-center justify-center text-current')}>
        <ICON__check className="!size-3.5 !text-component" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});

UI_PRIMITIVE__checkbox.displayName = CheckboxPrimitive.Root.displayName;
